import { render } from "./HowToUsePortal.vue?vue&type=template&id=9b904b00&scoped=true"
import script from "./HowToUsePortal.vue?vue&type=script&lang=js"
export * from "./HowToUsePortal.vue?vue&type=script&lang=js"

import "./HowToUsePortal.vue?vue&type=style&index=0&id=9b904b00&scoped=true&lang=css"
import "./HowToUsePortal.vue?vue&type=style&index=1&id=9b904b00&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b904b00"]])

export default __exports__